import React from 'react';
import Camera, { FACING_MODES } from 'react-html5-camera-photo'
import ArrowSvg from '../../../../assets/images/back-white.svg'
import Div100vh from 'react-div-100vh';
import 'react-html5-camera-photo/build/css/index.css';
import './CustomCamera.scss'

function CustomCamera({ handlePicture, onClose }) {

  function handlePhotoDone(dataUri) {
    handlePicture(dataUri)
  }

  return (
    <Div100vh className='mobile-container'>
      <div className='camera-title'>
        <div onClick={() => onClose()}>
          <img src={ArrowSvg} alt='flecha' />
        </div>
        <p>Tomar foto</p>
      </div>
      <div className='camera-container'>
        <Camera
          onTakePhotoAnimationDone={dataUri => handlePhotoDone(dataUri)}
          onCameraError={() => alert('Debe permitir que este sitio web acceda a la cámara')}
          isFullScreen={false}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          isImageMirror={false}
          idealResolution={{ width: 640, height: 480 }}
        />
      </div>
    </Div100vh>
  )
}

export default CustomCamera
